<template>
    <div class="g pop-up-inner" :style="styleSet">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || '表格'"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g popup-table">
                    <gTable
                        ref="table"
                        :fixedHeader="false"
                        :table="content.table"
                        :haveSearch="content.haveSearch"
                        :havePageination="content.havePageination"
                        :setLength="content.setLength"
                        :setTitle="content.setTitle"
                        :focus="content.focus"
                        :displayToolBar="content.displayToolBar"
                        :check="content.check"
                        :download="content.download"
                        :haveBorder="content.haveBorder"
                        :drop="content.drop"

                        @sendEvent="receiveEvent"
                    >
                        <gAll
                            v-if="content.totalSet"
                            slot="bottom"

                            :obj="totalData"
                        ></gAll>
                    </gTable>
                </div>
            </div>
        </div>
        <div class="space"></div>
        <!-- <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList> -->
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import gTable from '@/components/gTable'
    import gAll from '@/components/gAll'
    import mdBtnList from '@/components/mdBtnList'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            gTable,
            gAll,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: { //依照模板定義
                type: Object,
                require: false
            }
        },
        data: function(){
            let $styleSet = {};

            let _width = this.content.width;

            if( _width && typeof _width === 'number' ) {
                $styleSet.width = _width +'px';
            }else if( _width && typeof _width === 'string') {
                $styleSet.width = _width;
            }else {
                $styleSet.width = 'auto';
            }

            return {
                styleSet: $styleSet
            }
        },
        computed: {
            haveAction: function() {
                return this.content.action && typeof this.content.action === 'function';
            },
            totalData: function(){
                let $content = this.content;

                let $table = $content.table,
                    $title = $table.title,
                    $$content = $table.content;

                let $totalSet = $content.totalSet;

                let $result = [];

                $totalSet.forEach(item => {
                    let _prop = null,
                        _caption = null,
                        _suffix = '加總',
                        _total = 0;

                    let _base = 1000;

                    if( typeof item === 'string' ) {
                        _prop = item;

                        let $target = $title.find($item => {
                                return $item.prop === item;
                            });

                        if( $target ) {
                            _caption = $target.caption;
                        }else {
                            _caption = item;
                        }
                    }else {
                        _prop = item.prop;
                        _caption = item.caption;

                        if( item.suffix ) {
                            _suffix = item.suffix;
                        }
                    }

                    $$content.forEach($item => {

                        if( $item.show ) {
                            let _value = parseFloat($item[_prop]);

                            _value = _value * _base;

                            if( _value ) {
                                _total += _value;
                            }
                        }
                    });

                    _total = _total / _base;

                    $result.push({
                        caption: _caption + _suffix,
                        content: this.$okaTool.stringFormatToNumber(_total, 2)
                    });
                });

                return $result;
            },
            btns: function(){
                let $content = this.content || {},
                    $moreBtns = $content.moreBtns || []

                let $action = {
                        text: $content.actionName || this.$t('site.status.confirm'),
                        icon: $content.actionIcon || '',
                        themes: $content.actionTheme? $content.actionTheme: 'major',
                        func: 'action',
                    },
                    $cancel = {
                        text: $content.cancelName || this.$t('site.func.popupclose'),
                        icon: $content.cancelIcon || '',
                        themes: $content.cancelTheme || '',
                        func: 'close',
                    }

                let $results = [].concat($moreBtns);

                if( this.haveAction ) {
                    $results.push($action);
                }

                $results.push($cancel);

                return $results;
            },
        },
        methods: {
            receiveEvent: function() {
                this.$siteTool.receiveEvent(this.content, arguments);
            },
            sendFuncEvent: function(func){ //多 btn 功能
                let $content = this.content;

                $content[func]($content.table);
            },
            action: function(){
                let $content = this.content,
                    $table = $content.table;

                let $refTable = this.$refs.table,
                    $_validate = $refTable.validate,
                    $validate = $refTable.validate(),
                    $_doAction = () => {

                        if( this.haveAction ) {
                            $content.action($table);
                        }

                        if( $content.actionStopClose !== true ) {
                            this.close();
                        }
                    }

                if( $validate.then ) {

                    $validate.then(result => {

                        if (!result){
                            //啊就沒通過啊
                        }else {
                            $_doAction();
                        }
                    });
                }else {
                    $_doAction();
                }
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            }
        }
    }
</script>

<style scoped lang="scss">

    .g.all {
        margin: 16px 0;
    }

    .space{
        height: $interval-l;
    }
</style>
